export const reservationsEn = {
  hero: {
    title: 'Book a Table',
    subtitle: 'Reserve your table and experience authentic Neapolitan cuisine',
  },
  form: {
    guestInfoTitle: 'Guest Information',
    reservationDetailsTitle: 'Reservation Details',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number (optional)',
    guests: 'Number of Guests',
    date: 'Date',
    time: 'Time',
    note: 'Add a note (optional)',
    button: 'Reserve Table',
    submitting: 'Booking...',
    confirmation:
      'Your reservation request has been sent successfully. We will confirm your booking shortly via email!',
    defaultNote: 'You will receive a confirmation email once your reservation is confirmed.',
    placeholders: {
      name: 'Your name',
      email: 'Your email',
      phone: 'Your phone number',
      note: 'Any special requests, dietary requirements, or celebration details...',
    },
    timeOptions: {
      select: 'Select a time',
    },
    guestOptions: {
      guest: 'Guest',
      guests: 'Guests',
      nineplus: '9+ Guests',
    },
    success:
      'Thank you for your reservation request! We will confirm your booking shortly via email.',
    submitting: 'Booking...',
  },
  sidebar: {
    hours: {
      title: 'Opening Hours',
      weekdays: 'Monday - Saturday: 12:00 - 22:00',
      sunday: 'Sunday: 17:00 - 22:00',
    },
    groupBookings: {
      title: 'Group Bookings',
      description:
        'For groups of 9 or more, please contact us directly to arrange your reservation.',
    },
    policy: {
      title: 'Reservation Policy',
      items: [
        'Reservations are held for 15 minutes past the booking time',
        'For cancellations, please notify us at least 2 hours in advance',
        'Special requests are subject to availability',
        "Children's high chairs are available upon request",
      ],
    },
  },
};
